import { API } from "@/services/api";
import { teamEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import {
  ExternalTeamParams,
  ExternalTeamResponse,
  InternalTeamParams,
  InternalTeamResponse,
} from "@/types/team.types";

export const getInternalTeamService = async (
  params: InternalTeamParams = {}
): Promise<InternalTeamResponse> => {
  const response = await API.Get<InternalTeamResponse>(`${teamEndpoints.internal}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const getExternalTeamService = async (
  params: ExternalTeamParams = {}
): Promise<ExternalTeamResponse> => {
  const response = await API.Get<ExternalTeamResponse>(`${teamEndpoints.external}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
